import featureToggleService, {
    FeatureToggle,
} from "services/featureToggleService";
// Transcript UI exclusive annotation types
export default {
    agentempathy: {
        iconClassName: "icon-face-empathy",
        labelKey: "annotation.agentEmpathy",
    },
    unhelpfulbehavior: {
        iconClassName: "icon-face-neutral",
        labelKey: "annotation.unhelpfulBehavior",
    },
    positivesentiment: {
        iconClassName: "icon-thumbs-up",
        labelKey: "annotation.sentiment",
    },
    negativesentiment: {
        iconClassName: "icon-thumbs-down",
        labelKey: "annotation.sentiment",
    },
    topic: {
        iconClassName: "topic",
        labelKey: "annotation.topic",
    },
    combinedsentiments: {
        iconClassName: "fa fa-ellipsis-h",
        iconName: "fa/ellipsis-regular",
        className: "combined-sentiments",
        labelKey: "annotation.sentiments",
    },
    combinedsentimentspositive: {
        iconClassName: "fa fa-ellipsis-h combined-positive-sentiment",
        iconName: "fa/ellipsis-regular",
        className: "combined-positive-sentiment",
        labelKey: "annotation.sentiments",
    },
    combinedsentimentsnegative: {
        iconClassName: "fa fa-ellipsis-h combined-negative-sentiment",
        iconName: "fa/ellipsis-regular",
        className: "combined-negative-sentiment",
        labelKey: "annotation.sentiments",
    },
    combinedtopics: {
        iconClassName: "fa fa-ellipsis-h combined-topics",
        iconName: "fa/ellipsis-regular",
        className: "combined-topics",
        labelKey: "annotation.topics",
    },
    combinedevents: {
        iconClassName: "fa fa-ellipsis-h",
        iconName: "fa/ellipsis-regular",
        className: "combined-events",
        labelKey: "annotation.events",
    },
};
